<script setup>
import BaseTooltip from '@/components/Base/BaseTooltip.vue';

defineProps({
  size: {
    type: String,
    required: false,
    default: 'md',
    validator: (v) => ['sm', 'md'].includes(v),
  },
  staffingProspect: {
    type: Object,
    required: false,
    default: undefined,
  },
});
</script>

<template>
  <div
    class="rounded-full flex items-center justify-center cursor-pointer shrink-0 bg-proxify-gray-900"
    :class="size === 'sm' ? 'w-[20px] h-[20px]' : 'w-[24px] h-[24px]'"
    data-testid="staffing-prospect-badge"
  >
    <span
      class="text-white font-bold"
      :class="size === 'sm' ? 'text-[10px]' : 'text-body-xs'"
    >
      S
    </span>
    <BaseTooltip
      tooltip-class="border border-proxify-gray-200 shadow-lg"
      :offset="[0, 6]"
    >
      <div class="flex flex-col gap-1">
        <div class="text-body-sm font-bold text-proxify-gray-900">
          {{ staffingProspect?.title }}
        </div>
        <div class="text-body-xs font-normal text-proxify-gray-600">
          {{ staffingProspect?.description }}
        </div>
      </div>
    </BaseTooltip>
  </div>
</template>
